import { useState } from "react";
import { api, parseApiError } from "../lib/api";

export default function AdminLogin({ onSuccess, initialError }) {
  const [passcode, setPasscode] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState(initialError || null);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr(null);
    try {
      await api.post("/admin/login", { passcode });
      onSuccess();
    } catch (e) {
      setErr(parseApiError(e) || "Invalid passcode");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="admin-login-bg" data-testid="admin-login">
      <form className="admin-login-card" onSubmit={submit} data-testid="admin-login-form">
        <div className="admin-login-brand">
          <div className="admin-login-mark">Aquarius · Admin</div>
          <div className="admin-login-sub">Ocho Rios · Operator dashboard</div>
        </div>
        <label className="admin-login-label" htmlFor="admin-passcode">Passcode</label>
        <input
          id="admin-passcode"
          data-testid="admin-passcode"
          type="password"
          autoFocus
          value={passcode}
          onChange={(e) => setPasscode(e.target.value)}
          className="admin-login-input"
          placeholder="Enter operator passcode"
        />
        {err && <div className="admin-login-err" data-testid="admin-login-err">{err}</div>}
        <button
          type="submit"
          data-testid="admin-login-submit"
          className="admin-login-btn"
          disabled={busy || !passcode}
        >{busy ? "Signing in…" : "Sign in"}</button>
        <p className="admin-login-hint">Operator-only access. Sessions last 8 hours.</p>
      </form>
    </div>
  );
}
